var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNever(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_481_12171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.85938 0H4.26562V1.40625H2.85938V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48438 0H9.89062V1.40625H8.48438V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1094 0H15.5156V1.40625H14.1094V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7812 0H21.1875V1.40625H19.7812V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5157 14.8594C15.5157 12.921 13.9385 11.3438 12.0001 11.3438C11.2848 11.3438 10.6203 11.561 10.0645 11.9295L14.93 16.795C15.2985 16.2392 15.5157 15.5747 15.5157 14.8594Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.375C12.7153 18.375 13.3798 18.1578 13.9357 17.7893L9.07008 12.9237C8.70159 13.4796 8.48438 14.1441 8.48438 14.8594C8.48438 16.7978 10.0616 18.375 12 18.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 3.51562H19.7812V1.40625H15.5156V3.51562H14.1094V1.40625H9.89062V3.51562H8.48438V1.40625H4.26562V3.51562H2.85938V1.40625H0V5.625H24V1.40625H21.1875V3.51562Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24H18.375V19.7812H24V7.03125H0V24ZM12 9.9375C14.7141 9.9375 16.9219 12.1453 16.9219 14.8594C16.9219 17.5734 14.7141 19.7812 12 19.7812C9.28594 19.7812 7.07812 17.5734 7.07812 14.8594C7.07812 12.1453 9.28594 9.9375 12 9.9375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.588 21.1875H19.7812V24H20.7755L23.588 21.1875Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_481_12171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNever);
export default __webpack_public_path__ + "static/media/never.a4389be42d992e757f9df4b290b34210.svg";
export { ForwardRef as ReactComponent };